// extracted by mini-css-extract-plugin
export var content = "otBoutique-module--content--017c7";
export var imageWrapper = "otBoutique-module--imageWrapper--9a0fe";
export var widgetCart = "otBoutique-module--widgetCart--f15c7";
export var widgetPrice = "otBoutique-module--widgetPrice--a14e8";
export var wrapper = "otBoutique-module--wrapper--ea029";